export default "__VITE_ASSET__DwD6NMt7__"